export default __webpack_public_path__ + "static/media/element_98.46c5d655.webp";